import React, {useEffect, useRef, useState} from 'react'
import {toAbsoluteUrl, KTSVG, useDebounce} from '../../../../../_metronic/helpers'
import {useDispatch, useSelector} from 'react-redux'
import {
  GetClickThroughData,
  GetClickThroughPieChart,
  GetClickThroughlineChart,
  GetReportId,
  GetSingleMessageData,
  getDataOfClickthroughLineChart,
  getDataOfClickthroughPieChart,
  getDataOfClickthroughTable,
} from '../reportSlices/reportAnalytics'
import ReactApexChart from 'react-apexcharts'
import moment from 'moment-timezone'
import ReactPaginate from 'react-paginate'
import NodataYet from '../../../../Components/NodataYet'
import IpInfoModel from './IpInfoModel'
import {
  useGetCampaignReportCustomerClicksListQuery,
  useLazyGetCampaignReportCustomerClicksListExportQuery,
} from '../../../../../services/cellcast'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {Spinner} from 'react-bootstrap'
import {useLazyBulkMessageShortLinkBarChartQuery} from '../../../../../services/cellcast.v2'
import {getIsDefaultRegion} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {
  useFetchReportPaginateListGroupQuery,
  useGetCountWithGroupQuery,
  useGetReportLineChartsQuery,
} from '../../../../../services/cellcast.v3'
const API_DOMAIN = ENV().REACT_APP_DOMAIN

const ShortLink = () => {
  const messageData = useSelector(GetSingleMessageData)
  // const clickThrough = useSelector(GetClickThroughData)
  const clickThroughLine = useSelector(GetClickThroughlineChart)
  const clickThroughPie = useSelector(GetClickThroughPieChart)
  const ReportId = useSelector(GetReportId)
  const [selectedIP, setSelectedIP] = useState<string | null>(null)
  const [IpModel, setIpModel] = useState<boolean>(false)
  const [search, setSearch] = useState({
    searchValue: '',
    page: 1,
  })
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const [getCampaignReportCustomerClickList, {isFetching: isExportLoading}] =
    useLazyGetCampaignReportCustomerClicksListExportQuery()
  const [getBarChartData, {data: platformData, isFetching: isFetchBarChart}] =
    useLazyBulkMessageShortLinkBarChartQuery()

  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)
  const [dateRange, setDateRange] = useState<any>([sevenDaysAgo, new Date()])

  const [startDate, endDate] = dateRange
  const {isFetching: isLoadClickList, data: clickThrough} =
    useGetCampaignReportCustomerClicksListQuery({
      campId: ReportId?.id,
      params: {camp_type: ReportId?.camp_type, ...search},
    })

  const [platformChartData, setPlatformChartData] = useState({
    series: [],
    options: {
      chart: {
        type: 'bar',
      },
      xaxis: {
        categories: [],
      },
      title: {
        text: 'Platform Usage',
      },
      plotOptions: {
        bar: {
          horizontal: false,
        },
      },
    },
  })

  const dispatch = useDispatch()
  // const debouncedSearchTerm = useDebounce(search.searchValue, 300)
  // useEffect(() => {
  //   dispatch(
  //     getDataOfClickthroughTable({
  //       id: ReportId?.id,
  //       params: {camp_type: ReportId?.camp_type, ...search},
  //     })
  //   )
  // }, [debouncedSearchTerm, search])
  useEffect(() => {
    dispatch(
      getDataOfClickthroughPieChart({id: ReportId?.id, params: {camp_type: ReportId?.camp_type}})
    )
    dispatch(
      getDataOfClickthroughLineChart({id: ReportId?.id, params: {camp_type: ReportId?.camp_type}})
    )
    getBarChartData(ReportId?.id)
  }, [])

  const webLinkSeries = Array.isArray(clickThroughPie)
    ? clickThroughPie?.map((key: any) => Math.ceil(key?.percentage))
    : []
  const webLinkLabel = Array.isArray(clickThroughPie)
    ? clickThroughPie?.map((key: any, index: any) =>
        clickThroughPie?.length == index + 1 ? 'Landing' : `Web link ${index + 1}`
      )
    : []

  const smartLinkData: any = {
    series: webLinkSeries,
    options: {
      chart: {
        type: 'donut',
      },
      labels: webLinkLabel,
    },
  }

  const lineSeries = clickThroughLine?.map((key: any) => [moment(key?._id), key?.count]) || []

  const lineData: any = {
    series: [
      {
        name: 'Clicks',
        data: [...lineSeries],
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,

        zoom: {
          type: 'x',
          enabled: false,
          autoScaleYaxis: true,
        },
        toolbar: {
          autoSelected: 'zoom',
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: '',
        align: 'left',
      },

      xaxis: {
        type: 'datetime',
      },
      tooltip: {
        shared: false,
      },
    },
  }

  useEffect(() => {
    if (
      platformData &&
      platformData.data &&
      Array.isArray(platformData.data) &&
      platformData.data.length > 0
    ) {
      const platforms = platformData.data.map((item) => item.platform)
      const counts = platformData.data.map((item) => item.total)

      setPlatformChartData({
        series: [
          {
            name: 'Click Through By Platform',
            data: counts,
          },
        ] as never[],
        options: {
          ...platformChartData.options,
          xaxis: {
            categories: platforms as never[],
          },
          dataLabels: {
            enabled: true,
            offsetY: +20,
            style: {
              fontSize: '14px',
              colors: ['#304758'],
            },
          },
          yaxis: {
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
            labels: {
              show: true,
            },
          },
        },
      } as any)
    }
  }, [platformData])

  // get region data
  const {data: lineChartClickData} = useGetReportLineChartsQuery(
    {
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
      scope: 'click-through',
      type: 'message',
      bulkId: ReportId?.id,
    },
    {
      skip: isDefaultRegion,
    }
  )

  const lineSeriesRegion =
    lineChartClickData?.data?.items?.map((key: any) => [moment(key?._id), key?.count]) || []

  const lineDataRegion: any = {
    series: [
      {
        name: 'Clicks',
        data: [...lineSeriesRegion],
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,

        zoom: {
          type: 'x',
          enabled: false,
          autoScaleYaxis: true,
        },
        toolbar: {
          autoSelected: 'zoom',
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: '',
        align: 'left',
      },

      xaxis: {
        type: 'datetime',
      },
      tooltip: {
        shared: false,
      },
    },
  }

  const {data: getCountWithGroup} = useGetCountWithGroupQuery({
    fromDate: moment(startDate).format('YYYY-MM-DD'),
    toDate: moment(endDate).format('YYYY-MM-DD'),
    scope: 'click-through',
    type: 'message',
    bulkId: ReportId?.id,
    group: 'metadata.platform',
  })

  const {data: clickThroughData, isLoading: isLoadingClickThrough} =
    useFetchReportPaginateListGroupQuery(
      {
        page: search.page,
        limit: 10,
        scope: 'click-through',
        messageType: 'sms',
        type: 'message',
        group: 'metadata.contactId',
        bulkId: ReportId?.id,
      },
      {
        skip: isDefaultRegion,
      }
    )

  const platformChartDataRegion = {
    series: [
      {
        name: 'Click Through By Platform',
        data: getCountWithGroup?.data?.items?.map((it: any) => it?.total),
      },
    ],
    options: {
      chart: {
        type: 'bar',
      },
      xaxis: {
        categories: getCountWithGroup?.data?.items?.map((it: any) => {
          if (it?._id) {
            return it?._id
          }

          if (it?.id) {
            return it?.id === '' ? 'unknown' : it?.id
          }

          return 'unknown'
        }),
      },
      dataLabels: {
        enabled: true,
        offsetY: +20,
        style: {
          fontSize: '14px',
          colors: ['#304758'],
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: true,
        },
      },
      title: {
        text: 'Platform Usage',
      },
      plotOptions: {
        bar: {
          horizontal: false,
        },
      },
    },
  }

  const handleExport = () => {
    getCampaignReportCustomerClickList({
      campId: ReportId?.id,
    })
      .unwrap()
      .then((res: any) => {
        if (res?.data?.downloadurl) {
          let basePath = API_DOMAIN || ''
          window.open(`${basePath}${res?.data?.downloadurl}`, '_self')
        }
      })
  }

  const renderRegionData = () => {
    const messageData = ReportId?.data
    return (
      <>
        <IpInfoModel
          show={IpModel}
          selectedIP={selectedIP}
          handleClose={() => {
            setSelectedIP(null)
            setIpModel(false)
          }}
        />
        <div className='row mx-n4'>
          <div className='col-md-8 px-4 mb-8 mb-md-0'>
            <div className='card p-8 py-5 h-100 Analytics_chart_page'>
              <div className='card-header border-0 p-0 align-items-center'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>
                    Click through link tracking
                  </span>
                  <span className='text-muted mt-1 fw-bold fs-7'>
                    Customers are automatically unsubscribed
                  </span>
                </h3>
              </div>
              <div className='card-body px-0 pt-0'>
                <div className='tab-content'>
                  <div
                    className='tab-pane active'
                    id='Today'
                    role='tabpanel'
                    aria-labelledby='Today-tab'
                  >
                    <div className='analytics_charts'>
                      <div className='chart_head'>
                        <div className='chart_item'>
                          <strong>{messageData?.tracking_link_click_count}</strong>
                          <span>Click Total</span>
                        </div>
                      </div>
                      {lineChartClickData?.data?.items?.length ? (
                        <div className='chart_body'>
                          {/* <img src='/dashboard/media/misc/link_tracking_chart.png' alt='Image' /> */}
                          <ReactApexChart
                            options={lineDataRegion.options}
                            series={lineDataRegion.series}
                            type='line'
                            width={'100%'}
                          />
                        </div>
                      ) : (
                        <NodataYet />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-4 px-4'>
            <div className='card p-8 py-5 h-100 justify-content-center align-items-center'>
              <div className='text-center'>
                <h3 className='text-muted fw-light'>Coming Soon</h3>
              </div>
              {/* <div className='card-header border-0 p-0 align-items-center'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>Click through</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>Links clicked</span>
                </h3>
              </div>
              <div className='card-body px-0 pt-5'>
                <div className='optout_summary_chart'>
                  {webLinkSeries?.filter((key: any) => key > 0)?.length > 0 ? (
                    <div className='chart_body'>
                      <ReactApexChart
                        options={smartLinkData.options}
                        series={smartLinkData.series}
                        type='donut'
                      />
                    </div>
                  ) : (
                    <NodataYet message={'No links were clicked'} />
                  )}
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className='row mt-10 '>
          <div className='col-md-12 px-5 mb-8 mb-md-0'>
            <div className='card p-8 py-5 h-100 Analytics_chart_page'>
              <div className='card-header border-0 p-0 align-items-center'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>
                    Click through link tracking By Platform
                  </span>
                </h3>
              </div>
              <div className='card-body px-0 pt-0'>
                <div className='tab-content'>
                  <div
                    className='tab-pane active'
                    id='Today'
                    role='tabpanel'
                    aria-labelledby='Today-tab'
                  >
                    <div className='analytics_charts'>
                      {/* <div className='chart_head'>
                      <div className='chart_item'>
                        <strong>{messageData?.clickThrough}</strong>
                        <span>Click Total</span>
                      </div>
                    </div> */}
                      {getCountWithGroup?.data?.items?.length > 0 ? (
                        <div className='chart_body'>
                          {/* <img src='/dashboard/media/misc/link_tracking_chart.png' alt='Image' /> */}
                          <ReactApexChart
                            options={platformChartDataRegion.options as any}
                            series={platformChartDataRegion.series}
                            type='bar'
                            height={350}
                          />
                        </div>
                      ) : (
                        <NodataYet />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row mt-8'>
          <div className='col-12'>
            <div className='card mb-0 pt-7'>
              <div className='card-header align-items-center border-bottom-0'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>Click-through</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>
                    See all your clicks in one place
                  </span>
                </h3>
              </div>
              <div className='card-body pt-2'>
                {clickThroughData?.data?.items?.length > 0 ? (
                  <div className='tab-content'>
                    <div className='table-responsive'>
                      <table className='table align-middle gs-0 gy-5'>
                        <thead>
                          <tr className='fw-bold text-muted text-uppercase'>
                            <th>Mobile</th>
                            <th>Full Name</th>
                            {messageData?.tracking_links?.map((val: any, index: number) => (
                              <th key={index} className='text-center'>
                                {`Link ${index + 1}-{${val?.redirect_url}} - Click `}
                              </th>
                            ))}
                            {clickThroughData?.data?.items
                              ?.at(0)
                              ?.landingpageshortcodes?.map((key: any, index: number) => (
                                <>
                                  <th key={index} className='text-center'>{`Response`}</th>
                                  <th key={index} className='text-center'>{`LANDING PAGE`}</th>
                                </>
                              ))}
                          </tr>
                        </thead>
                        <tbody className='text-gray-600'>
                          {clickThroughData?.data?.items?.map((key: any, i: number) => (
                            <tr className='border-dashed border-1 border-bottom' key={i}>
                              <td>{key?.metadata?.receiver}</td>
                              <td>
                                {key?.metadata?.receiver_name ? key?.metadata?.receiver_name : '-'}
                              </td>
                              {messageData?.tracking_links?.map((val: any, index: number) => (
                                <td key={index} className='text-center'>
                                  {val?.redirect_url === key?.metadata?.url ? (
                                    <>
                                      <button
                                        className='btn btn-custom btn-primary w-auto py-2 message-btn'
                                        onClick={() => {
                                          setSelectedIP(key?.metadata?.ip)
                                          setIpModel(true)
                                        }}
                                      >
                                        <span className='btn-label'>
                                          {key?.metadata?.ip} - {key?.count}
                                        </span>
                                        <div>{key?.metadata?.platform}</div>
                                      </button>
                                    </>
                                  ) : (
                                    '--'
                                  )}
                                </td>
                              ))}

                              {/* {key?.analytics?.map((key: any) => (
                            <>
                              <td>{moment(key?.updatedAt).format('l')}</td>
                            </>
                          ))} */}

                              {key?.landingpageshortcodes?.map((key: any, i: number) =>
                                key?.updatedAt && key?.click !== 0 ? (
                                  <>
                                    <td className='text-center'>{key?.response}</td>
                                    <td key={i} className='text-center'>
                                      {`${moment(key?.updatedAt).format('l')} at ${moment(
                                        key?.updatedAt
                                      ).format('LT')}`}
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    <td>--</td>
                                    <td>--</td>
                                  </>
                                )
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className='abcd '>
                      <span>Total: {clickThroughData?.data?.total}</span>
                      <ReactPaginate
                        previousLabel='<'
                        nextLabel='>'
                        pageCount={clickThroughData?.totalPages}
                        onPageChange={(e: any) => setSearch({...search, page: e?.selected + 1})}
                        containerClassName={'pagiantion'}
                        previousLinkClassName={'pagination__link'}
                        nextLinkClassName={'pagination__link'}
                        disabledClassName={'pagination__link--disabled'}
                        activeClassName={'pagination__link--active'}
                      />
                    </div>
                  </div>
                ) : (
                  <NodataYet message={'No links were clicked'} />
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  const renderDefaultRegion = () => {
    return (
      <>
        <IpInfoModel
          show={IpModel}
          selectedIP={selectedIP}
          handleClose={() => {
            setSelectedIP(null)
            setIpModel(false)
          }}
        />
        <div className='row mx-n4'>
          <div className='col-md-8 px-4 mb-8 mb-md-0'>
            <div className='card p-8 py-5 h-100 Analytics_chart_page'>
              <div className='card-header border-0 p-0 align-items-center'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>
                    Click through link tracking
                  </span>
                  <span className='text-muted mt-1 fw-bold fs-7'>
                    Customers are automatically unsubscribed
                  </span>
                </h3>
              </div>
              <div className='card-body px-0 pt-0'>
                <div className='tab-content'>
                  <div
                    className='tab-pane active'
                    id='Today'
                    role='tabpanel'
                    aria-labelledby='Today-tab'
                  >
                    <div className='analytics_charts'>
                      <div className='chart_head'>
                        <div className='chart_item'>
                          <strong>{messageData?.clickThrough}</strong>
                          <span>Click Total</span>
                        </div>
                      </div>
                      {clickThroughLine?.length > 0 ? (
                        <div className='chart_body'>
                          {/* <img src='/dashboard/media/misc/link_tracking_chart.png' alt='Image' /> */}
                          <ReactApexChart
                            options={lineData.options}
                            series={lineData.series}
                            type='line'
                            width={'100%'}
                          />
                        </div>
                      ) : (
                        <NodataYet />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-4 px-4'>
            <div className='card p-8 py-5 h-100'>
              <div className='card-header border-0 p-0 align-items-center'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>Click through</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>Links clicked</span>
                </h3>
              </div>
              <div className='card-body px-0 pt-5'>
                <div className='optout_summary_chart'>
                  {webLinkSeries?.filter((key: any) => key > 0)?.length > 0 ? (
                    <div className='chart_body'>
                      <ReactApexChart
                        options={smartLinkData.options}
                        series={smartLinkData.series}
                        type='donut'
                      />
                    </div>
                  ) : (
                    <NodataYet message={'No links were clicked'} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row mt-10 '>
          <div className='col-md-12 px-5 mb-8 mb-md-0'>
            <div className='card p-8 py-5 h-100 Analytics_chart_page'>
              <div className='card-header border-0 p-0 align-items-center'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>
                    Click through link tracking By Platform
                  </span>
                </h3>
              </div>
              <div className='card-body px-0 pt-0'>
                <div className='tab-content'>
                  <div
                    className='tab-pane active'
                    id='Today'
                    role='tabpanel'
                    aria-labelledby='Today-tab'
                  >
                    <div className='analytics_charts'>
                      {/* <div className='chart_head'>
                      <div className='chart_item'>
                        <strong>{messageData?.clickThrough}</strong>
                        <span>Click Total</span>
                      </div>
                    </div> */}
                      {clickThroughLine?.length > 0 ? (
                        <div className='chart_body'>
                          {/* <img src='/dashboard/media/misc/link_tracking_chart.png' alt='Image' /> */}
                          <ReactApexChart
                            options={platformChartData.options as any}
                            series={platformChartData.series}
                            type='bar'
                            height={350}
                          />
                        </div>
                      ) : (
                        <NodataYet />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row mt-8'>
          <div className='col-12'>
            <div className='card mb-0 pt-7'>
              <div className='card-header align-items-center border-bottom-0'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>Click-through</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>
                    See all your clicks in one place
                  </span>

                  <div className='mt-2'>
                    <div className='card-label fw-bolder fs-2 mb-1 d-flex justify-content-between'>
                      <div>Total Clicks :</div>
                      <span className='text-muted mt-1 fw-bold fs-7'>
                        {messageData?.clickThrough}
                      </span>
                    </div>
                    <div className='card-label fw-bolder fs-2 mb-1 d-flex justify-content-between'>
                      <div>Total Subscriber Click :</div>
                      <span className='text-muted mt-1 fw-bold fs-7'>
                        {clickThrough?.data?.total}
                      </span>
                    </div>
                  </div>
                </h3>
                <div className='d-flex justify-content-end'>
                  <div className='ms-2 col-xs-2'>
                    {isDefaultRegion && (
                      <button
                        onClick={handleExport}
                        type='button'
                        className='btn btn-light-primary'
                      >
                        {isExportLoading ? (
                          <Spinner size='sm' />
                        ) : (
                          <>
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr078.svg'
                              className='svg-icon-2'
                            />
                            Export
                          </>
                        )}
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className='card-body pt-2'>
                {isLoadClickList ? (
                  <div className='d-flex m-auto justify-content-center align-items-center'>
                    <Spinner className='p-0' />
                  </div>
                ) : clickThrough?.data?.items?.length > 0 ? (
                  <div className='tab-content'>
                    <div className='table-responsive'>
                      <table className='table align-middle gs-0 gy-5'>
                        <thead>
                          <tr className='fw-bold text-muted text-uppercase'>
                            <th>Mobile</th>
                            <th>First Name</th>
                            <th>Full Name</th>
                            {clickThrough?.data?.items
                              ?.at(0)
                              ?.analytics?.map((key: any, index: number) => (
                                <th key={index} className='text-center'>
                                  {`Link ${index + 1}-{${key?.shorturl}} - Click `}
                                </th>
                              ))}
                            {clickThrough?.data?.items
                              ?.at(0)
                              ?.landingpageshortcodes?.map((key: any, index: number) => (
                                <>
                                  <th key={index} className='text-center'>{`Response`}</th>
                                  <th key={index} className='text-center'>{`LANDING PAGE`}</th>
                                </>
                              ))}
                          </tr>
                        </thead>
                        <tbody className='text-gray-600'>
                          {clickThrough?.data?.items?.map((key: any, i: number) => (
                            <tr className='border-dashed border-1 border-bottom' key={i}>
                              <td>{key?.mobile}</td>
                              <td>
                                {key?.fields?.find(
                                  (key: any) =>
                                    key?.name?.toLowerCase()?.replace(/ +/g, '') === 'firstname'
                                )
                                  ? key?.fields?.find(
                                      (key: any) =>
                                        key?.name?.toLowerCase()?.replace(/ +/g, '') === 'firstname'
                                    )?.value
                                  : '-'}
                              </td>
                              <td>
                                {key?.fields?.find(
                                  (key: any) =>
                                    key?.name?.toLowerCase()?.replace(/ +/g, '') === 'fullname'
                                )
                                  ? key?.fields?.find(
                                      (key: any) =>
                                        key?.name?.toLowerCase()?.replace(/ +/g, '') === 'fullname'
                                    )?.value
                                  : '-'}
                              </td>
                              {key?.analytics?.map((val: any, index: number) =>
                                val?.updatedAt && val?.click !== 0 ? (
                                  <td key={index} className='text-center'>
                                    {/* <div>
                                    <div>{`${moment(val?.updatedAt).format('l')} at ${moment(
                                      val?.updatedAt
                                    ).format('LT')}`}</div>
                                    <div>IP:- {val?.ip}</div>
                                    <div>Platform:- {val?.platform}</div>
                                    <div>Country:- {val?.country}</div>
                                    <div>Click:- {val?.click}</div>
                                  </div> */}
                                    <button
                                      className='btn btn-custom btn-primary w-auto py-2 message-btn'
                                      onClick={() => {
                                        setSelectedIP(val?.ip)
                                        setIpModel(true)
                                      }}
                                    >
                                      <span className='btn-label'>
                                        {val?.ip} - {val?.click}
                                      </span>
                                      <div>{val?.platform}</div>
                                    </button>
                                  </td>
                                ) : (
                                  <td>--</td>
                                )
                              )}

                              {/* {key?.analytics?.map((key: any) => (
                            <>
                              <td>{moment(key?.updatedAt).format('l')}</td>
                            </>
                          ))} */}

                              {key?.landingpageshortcodes?.map((key: any, i: number) =>
                                key?.updatedAt && key?.click !== 0 ? (
                                  <>
                                    <td className='text-center'>{key?.response}</td>
                                    <td key={i} className='text-center'>
                                      {`${moment(key?.updatedAt).format('l')} at ${moment(
                                        key?.updatedAt
                                      ).format('LT')}`}
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    <td>--</td>
                                    <td>--</td>
                                  </>
                                )
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <NodataYet message={'No links were clicked'} />
                )}

                <div className='abcd '>
                  <span>Total: {clickThrough?.data?.total}</span>
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={clickThrough?.data?.totalPages}
                    onPageChange={(e: any) => setSearch({...search, page: e.selected + 1})}
                    containerClassName={'pagiantion'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  return <>{isDefaultRegion ? renderDefaultRegion() : renderRegionData()}</>
}

export default ShortLink
